import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { BookingPageTagName } from '../../../../../domain/entities/BookingPage';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import BookingPageCard from '../../../common/cards/BookingPageCard';
import LabeledContainer from '../../../../common/LabeledContainer';

import css from './AvailableBookingPageList.module.scss';

interface Props {
  publicId: string;
  bookingPages: IPurchases.BookingPage[];
}

const tagsBy = (page: IPurchases.BookingPage) => {
  const tags: BookingPageTagName[] = [];
  if (page.tagNames.includes(BookingPageTagName.Accepting)) {
    tags.push(BookingPageTagName.Accepting);
  }
  return tags;
};

const AvailableBookingPageList = ({ publicId, bookingPages }: Props) => {
  const intl = useIntl();
  const classes = classNames(css.AvailableBookingPageList);

  return (
    <LabeledContainer
      className={classes}
      label={intl.formatMessage({
        id: `purchases.availableBookingPageList.title`,
      })}
      paddingTop={true}
    >
      {bookingPages.map((page, i) => (
        <BookingPageCard
          key={i}
          className={css.AvailableBookingPageList__BookingPageCard}
          title={page.name}
          description={page.descriptionText || ''}
          url={`/${publicId}/${page.publicId}#pageContent`}
          thumbnailUrl={
            page.primaryImage && page.primaryImage.thumb
              ? page.primaryImage.thumb.url
              : ''
          }
          tags={tagsBy(page)}
        />
      ))}
    </LabeledContainer>
  );
};

export default AvailableBookingPageList;
